import type { inferRouterOutputs } from "@trpc/server";

import type { AppRouter } from "@runcheetah/api/router";

type RouterOutputs = inferRouterOutputs<AppRouter>;
export type BillingAvailability = RouterOutputs["brand"]["getBillingAvailability"] | undefined;
export type BillingOverview = RouterOutputs["brand"]["getBillingOverview"] | undefined;

export type AssetCreationBillingGateState =
  | "allowed"
  | "loading"
  | "upgrade_required"
  | "unavailable";

export const getAssetCreationBillingGateState = ({
  availability,
  overview,
  availabilityPending,
  overviewPending,
}: {
  availability: BillingAvailability;
  overview: BillingOverview;
  availabilityPending: boolean;
  overviewPending: boolean;
}): AssetCreationBillingGateState => {
  if (availabilityPending || overviewPending) {
    return "loading";
  }

  if (!availability?.enabled) {
    return "allowed";
  }

  if (!overview) {
    return "unavailable";
  }

  const runsRemaining = overview.usage.credits.remaining;

  if (runsRemaining === null || runsRemaining <= 0) {
    return "upgrade_required";
  }

  return "allowed";
};
